export default (editor, pfx) => {
    const $ = editor.$;
    const assetsEl = $(`<div id="${pfx}pn-assets-container" class="${pfx}fadein" style="width: 96%;">
        <div class="${pfx}pn-assets-header">
            <div style="font-weight: bold;">Media</div>
            <p>What are you looking for?</p>
            <div class="${pfx}assets-search">
                <i class="fa fa-search"></i>
                <input type="text" placeholder="e.g business, fashion, fitness">
            </div>
            <p>Upload your media</p>
            <div class="${pfx}upload-btns">
                <i class="fa fa-upload"></i>
            </div>
        </div>
        <div class="${pfx}pn-assets">
            <p>Site files</p>
            <div class="${pfx}assets-grid">
            </div>
        </div>
    </div>`);
    const input = assetsEl.find('input');
    const uploadBtns = assetsEl.find(`.${pfx}upload-btns`);
    const assetsGrid = assetsEl.find(`.${pfx}assets-grid`);

    assetsGrid.html(updateAssets(editor));
    input.on('change', e => filter(editor, assetsGrid, e.target.value));
    uploadBtns.on('click', () => upload(editor));

    editor.on('load asset:add asset:remove', () => assetsGrid.html(updateAssets(editor)));

    return assetsEl;
}

const filter = (editor, assetsGrid, query) => {
    const am = editor.Assets
    const all = am.getAll();
    let filter = all;
    query && (filter = all.filter(asset => asset.get('src').split('/').pop().match(query) !== null)) ||
        (filter = all.filter(asset => true));
    am.render(filter);
    assetsGrid.html(updateAssets(editor));
};

const upload = (editor) => {
    editor.runCommand('open-assets', {
        target: null,
        types: ['image'], //extend if more asset types are added
        accept: 'image/*', //extend if more asset types are added
        onSelect: e => {} //do nothing
    });
};

const updateAssets = (editor) => {
    return editor.Assets.getAllVisible().map(asset => {
        return `<div class="img-container">
            <img src="${asset.get('src')}">
            <div class="gjs-pn-img-bg gjs-checker-bg"></div>
        </div>`
    }).join('\n');
};